const getCookie = (name) => {
  const value = " " + document.cookie;
  const parts = value.split(" " + name + "=");

  return parts.length < 2 ? undefined : parts.pop().split(";").shift();
};

var settings = {
  'ad_storage': 'denied',
  'ad_user_data': 'denied',
  'ad_personalization': 'denied',
  'analytics_storage': 'denied'
};

const setCookie = function (name, value, expiryDays, domain, path, secure) {
  if (value == "default") {
    gtag('consent', 'default', settings);
  } else {
    const exdate = new Date();
    
    exdate.setHours(
      exdate.getHours() +
        (typeof expiryDays !== "number" ? 365 : expiryDays) * 24
    );

    gtag('consent', 'update', settings);

    document.cookie =
      name +
      "=" +
      JSON.stringify(settings) +
      ";expires=" +
      exdate.toUTCString() +
      ";path=" +
      (path || "/") +
      (domain ? ";domain=" + domain : "") +
      (secure ? ";secure" : "");
  }
};

(() => {
  const $cookiesBanner = document.querySelector(".cookies-lazychimp-banner");
  const $cookiesBannerButton = $cookiesBanner.querySelector("button.accept");
  const $cookiesBannerDeclineButton = $cookiesBanner.querySelector("button.decline");

  const cookieName = "lazyChimpCookies";
  const hasCookie = getCookie(cookieName);

  if (hasCookie) {
    gtag('consent', 'update', JSON.parse(hasCookie));
  }

  $cookiesBannerDeclineButton.addEventListener("click", () => {
    setCookie(cookieName, "declined");
    document.documentElement.setAttribute('data-cc', 'set');
    $cookiesBanner.remove();
  });

  $cookiesBannerButton.addEventListener("click", () => {
    settings = {
      'ad_storage': document.getElementById('ads-cookies').checked ? 'granted' : 'denied',
      'ad_user_data': document.getElementById('user-data-cookies').checked ? 'granted' : 'denied',
      'ad_personalization': document.getElementById('personalization-cookies').checked ? 'granted' : 'denied',
      'analytics_storage': document.getElementById('analytics-cookies').checked ? 'granted' : 'denied'
    };
    setCookie(cookieName, "accepted");
    document.documentElement.setAttribute('data-cc', 'set');
    $cookiesBanner.remove();
  });

  // customize
  document.querySelector(".customize").addEventListener("click", () => {
    document.querySelector(".consent-options").classList.remove("hidden");
    document.querySelector(".accept").textContent = "Save Settings";
    document.querySelector(".customize").remove();
  });
})();